const mediaQueryBootstrapValues = {
  xs: {
    max: 575,
  },
  sm: {
    min: 576,
    max: 767,
  },
  md: {
    min: 768,
    max: 991,
  },
  lg: {
    min: 992,
    max: 1199,
  },
  xl: {
    min: 1200,
  },
};

const mediaQueryMixin = {
  data() {
    return {
      windowWidth: 0,
      windowHeight: 0,
      wXS: false,
      wSM: false,
      wMD: false,
      wLG: false,
      wXL: false,
    };
  },
  computed: {
    device() {
      if (this.wXS) {
        return 'wXS';
      } else if (this.wSM) {
        return 'wSM';
      } else if (this.wMD) {
        return 'wMD';
      } else if (this.wLG) {
        return 'wLG';
      } else if (this.wXL) {
        return 'wXL';
      }
      return '';
    },
    width() {
      return this.windowWidth;
    },
    height() {
      return this.windowHeight;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth);
      window.addEventListener('resize', this.getWindowHeight);
      this.getWindowWidth();
      this.getWindowHeight();
    });
  },
  methods: {
    getWindowWidth() {
      const w = document.documentElement.clientWidth;
      this.windowWidth = w;
      const mediaQuery = mediaQueryBootstrapValues;

      this.wXS = w <= mediaQuery.xs.max;
      this.wSM = w >= mediaQuery.sm.min && w <= mediaQuery.sm.max;
      this.wMD = w >= mediaQuery.md.min && w <= mediaQuery.md.max;
      this.wLG = w >= mediaQuery.lg.min && w <= mediaQuery.lg.max;
      this.wXL = w >= mediaQuery.xl.min;
    },

    getWindowHeight() {
      this.windowHeight = document.documentElement.clientHeight;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
    window.removeEventListener('resize', this.getWindowHeight);
  },
};
export default mediaQueryMixin;



// WEBPACK FOOTER //
// ./src/mixin/mediaquery.mixin.js